import { __decorate as e, __classPrivateFieldGet as t, __classPrivateFieldSet as i } from "tslib";
import { LitElement as s, html as o } from "lit";
import r from "../styles/global-styles.js";
import { stylesBase as n, styles1177 as a, styles1177pro as l, stylesInera as d, stylesIneraAdmin as c, stylesIneraLegacy as h, stylesIneraAdminLegacy as p } from "./header-styles.js";
import { property as g, state as u } from "lit/decorators.js";
import { generateId as b } from "../../utilities/utils.js";
var m, y, f, v, k, w, x, $, I, R, S, E, L;
class M extends s {
  constructor() {
    super(...arguments), m.set(this, ""), y.set(this, ""), f.set(this, ""), v.set(this, ""), k.set(this, "Välj region"), w.set(this, !1), x.set(this, !1), $.set(this, !1), I.set(this, "Logotyp"), R.set(this, !1), S.set(this, "javascript:void()"), E.set(this, !1), L.set(this, void 0), this.hasViewPortResizeEvent = !1, this.lastKnownRegionId = "", this.handleVPResize = () => {
      this.regionIcon && (visualViewport.width > 1024 && this.regionIcon ? this.regionIcon.setAttribute("slot", "region") : this.regionIcon.setAttribute("slot", "region-mobile"));
    };
  }
  get type() {
    return t(this, m, "f");
  }
  set type(e) {
    i(this, m, e, "f");
  }
  get brandtext() {
    return t(this, y, "f");
  }
  set brandtext(e) {
    i(this, y, e, "f");
  }
  get brandtexttop() {
    return t(this, f, "f");
  }
  set brandtexttop(e) {
    i(this, f, e, "f");
  }
  get brandtextbottom() {
    return t(this, v, "f");
  }
  set brandtextbottom(e) {
    i(this, v, e, "f");
  }
  get pickregiontext() {
    return t(this, k, "f");
  }
  set pickregiontext(e) {
    i(this, k, e, "f");
  }
  get hidebrand() {
    return t(this, w, "f");
  }
  set hidebrand(e) {
    i(this, w, e, "f");
  }
  get fluid() {
    return t(this, x, "f");
  }
  set fluid(e) {
    i(this, x, e, "f");
  }
  get hideregionpicker() {
    return t(this, $, "f");
  }
  set hideregionpicker(e) {
    i(this, $, e, "f");
  }
  get srlogolabel() {
    return t(this, I, "f");
  }
  set srlogolabel(e) {
    i(this, I, e, "f");
  }
  get unresponsive() {
    return t(this, R, "f");
  }
  set unresponsive(e) {
    i(this, R, e, "f");
  }
  get logohref() {
    return t(this, S, "f");
  }
  set logohref(e) {
    i(this, S, e, "f");
  }
  get isRegionExpanded() {
    return t(this, E, "f");
  }
  set isRegionExpanded(e) {
    i(this, E, e, "f");
  }
  get regionIcon() {
    return t(this, L, "f");
  }
  set regionIcon(e) {
    i(this, L, e, "f");
  }
  firstUpdated(e) {
    "1177" !== this.type || this.unresponsive || this.setup1177RegionIcon();
  }
  updated(e) {
    super.updated(e), "1177" === this.type && (this.hasViewPortResizeEvent || this.setup1177RegionIcon(), this.regionIcon = this.querySelector("[slot=region]") || this.querySelector("[slot=region-mobile]"), this.regionIcon && this.regionIcon.getAttribute("id") !== this.lastKnownRegionId && this.setRegionIconAttributes());
  }
  setRegionIconAttributes() {
    this.lastKnownRegionId = this.regionIcon.getAttribute("id") || b(), this.regionIcon.setAttribute("id", this.lastKnownRegionId), this.regionIcon.setAttribute("colorpreset", "4"), this.regionIcon.setAttribute("width", "100%"), this.regionIcon.setAttribute("height", "100%");
  }
  setup1177RegionIcon() {
    this.regionIcon = this.querySelector("[slot=region]") || this.querySelector("[slot=region-mobile]"), this.addEventListenerForRegionIcon();
  }
  addEventListenerForRegionIcon() {
    visualViewport.addEventListener("resize", this.handleVPResize), this.hasViewPortResizeEvent = !0, this.handleVPResize();
  }
  renderLogo() {
    return "1177" === this.type && this.regionIcon ? o`<ids-col cols="auto" class="header-logo-col header-fill"><ids-row align="center"><ids-col cols="auto">${this.renderLogoLink()}</ids-col><ids-col cols="auto"><div class="logo-region-divider"></div></ids-col><ids-col cols="auto"><slot name="region"></slot></ids-col></ids-row></ids-col>` : o`<ids-col cols="auto" class="header-logo-col header-fill ${this.hideregionpicker ? "no-picker" : ""}">${this.renderLogoLink()}</ids-col>`;
  }
  renderLogoLink() {
    return o`<div class="header-logo ${this.regionIcon || "1177" !== this.type ? "" : "logo-btn-spacer"}">${this.querySelector('[slot="logo"]') ? o`<slot name="logo"></slot>` : o`<a href="${this.logohref}" aria-label="${this.srlogolabel}" class="logo-btn btn-no-styles">${this.renderLogoIcon()}</a>`}</div>`;
  }
  renderLogoIcon() {
    if (!this.hidebrand) switch (this.type) {
      case "1177":
        return o`<ids-icon-1177 colorpreset="4" width="100%" height="100%"></ids-icon-1177>`;
      case "1177-pro":
        return o`<ids-icon-1177 color="var(--IDS-COLOR-ACCENT-40)" width="100%" height="100%"></ids-icon-1177>`;
      case "inera":
        return o`<ids-icon-inera color="var(--IDS-COLOR-PRIMARY-40)" width="100%" height="100%"></ids-icon-inera>`;
      case "inera-legacy":
        return o`<ids-icon-inera-legacy width="100%" height="100%"></ids-icon-inera-legacy>`;
    }
    return o``;
  }
  renderRegionPickerMobile() {
    return this.unresponsive ? null : o`<ids-col class="hide-on-desktop header-fill pick-region-mobile-col"><button @click="${this.toggleRegion}" class="btn-no-styles pick-region-mobile-btn"><ids-col cols="auto">${this.regionIcon ? o`<slot name="region-mobile"></slot>` : o`${this.pickregiontext}`}<slot name="avatar-left"></slot></ids-col><div class="grid-spacer"></div><ids-col cols="auto"><ids-icon-chevron-bold class="change-region-chevron ${this.isRegionExpanded ? "expanded" : ""}" color="white" width="0.438rem" height="0.75rem"></ids-icon-chevron-bold></ids-col></button></ids-col>`;
  }
  renderRegionPicker() {
    return this.hideregionpicker ? o`<ids-col cols="auto" class="no-picker header-fill"></ids-col><div class="grid-spacer"></div>` : o`${this.renderRegionPickerMobile()} ${this.renderRegionPickerDesktop()}`;
  }
  renderRegionPickerDesktop() {
    return o`<ids-col cols="auto" class="region-picker-col no-select ${this.unresponsive ? "" : "hide-on-mobile"}"><button @click="${this.toggleRegion}" class="btn-no-styles pick-region-btn"><ids-col class="change-region" cols="auto">${this.pickregiontext}</ids-col><ids-col alignself="center" cols="auto"><ids-icon-chevron-bold class="change-region-chevron ${this.isRegionExpanded ? "expanded" : ""}" color="#A00B36" width="0.438rem" height="0.75rem"></ids-icon-chevron-bold></ids-col></button></ids-col>`;
  }
  toggleRegion(e) {
    if (this.isValidKey(e)) {
      this.isRegionExpanded = !this.isRegionExpanded;
      let e = new CustomEvent("didToggleRegion", {
        detail: {
          isExpanded: this.isRegionExpanded
        }
      });
      this.dispatchEvent(e);
    }
  }
  isValidKey(e) {
    return "Space" === e.code || "Enter" === e.code && "keydown" === e.type || "click" === e.type;
  }
  renderItems() {
    switch (this.type) {
      case "1177":
      case "1177-pro":
      case "inera":
      case "inera-admin":
      case "inera-admin-legacy":
        return o`<ids-col class="header-items-wrapper" cols="auto"><ids-row class="header-items" align="center"><slot></slot></ids-row></ids-col>`;
      case "inera-legacy":
        return o`<ids-col class="header-items-wrapper" cols="auto"><ids-row justify="end" class="header-items" align="center"><slot></slot></ids-row><ids-row justify="end" class="header-nav"><slot name="header-nav"></slot></ids-row></ids-col>`;
      default:
        return o``;
    }
  }
  renderServiceName() {
    return "inera-admin" === this.type ? o`<ids-col>${this.renderBrandText()}<h2 class="header-service-name-inera">EN TJÄNST FRÅN INERA</h2></ids-col>` : o`<ids-col class="service-name-col">${this.brandtexttop ? o`<p class="header-unit-name top">${this.brandtexttop}</p>` : ""} ${this.renderBrandText()} ${this.brandtextbottom ? o`<p class="header-unit-name bottom">${this.brandtextbottom}</p>` : ""}</ids-col>`;
  }
  renderBrandText() {
    return this.brandtext ? o`<h1 class="header-service-name ${this.brandtexttop || this.brandtextbottom ? "is-supplemented" : ""}">${this.brandtext}</h1>` : this.querySelector('[slot="brand-text"]') ? o`<span class="${this.brandtexttop || this.brandtextbottom ? "is-supplemented" : ""}"><slot name="brand-text"></slot></span>` : o``;
  }
  renderHeader() {
    switch (this.type) {
      case "1177":
        return o`${this.renderLogo()} ${this.renderRegionPicker()}<div class="${this.unresponsive ? "grid-spacer" : "grid-spacer-desktop"}"></div>${this.renderItems()}`;
      case "1177-pro":
        return o`${this.renderLogo()} ${this.renderServiceName()} ${this.renderItems()}`;
      case "inera":
      case "inera-legacy":
        return o`${this.renderLogo()}<div class="grid-spacer"></div>${this.renderItems()}`;
      case "inera-admin":
      case "inera-admin-legacy":
        return o`${this.renderServiceName()} ${this.renderItems()}`;
      default:
        return o``;
    }
  }
  renderSkipToContent() {
    return this.querySelector("[slot=skip-to-content]") ? o`<div class="ids-skip-to-content"><slot name="skip-to-content"></slot></div>` : null;
  }
  render() {
    return o`<header><slot name="header-top"></slot>${this.renderSkipToContent()}<div class="header-main"><ids-container gutterless ?fluid="${this.fluid}"><ids-row class="header-inner">${this.renderHeader()}</ids-row></ids-container></div>${"inera-legacy" === this.type ? o`` : o`<slot name="header-nav"></slot>`}</header>`;
  }
}
m = new WeakMap(), y = new WeakMap(), f = new WeakMap(), v = new WeakMap(), k = new WeakMap(), w = new WeakMap(), x = new WeakMap(), $ = new WeakMap(), I = new WeakMap(), R = new WeakMap(), S = new WeakMap(), E = new WeakMap(), L = new WeakMap(), M.styles = [r, n, a, l, d, c, h, p], e([g({
  type: String,
  reflect: !0
})], M.prototype, "type", null), e([g({
  type: String
})], M.prototype, "brandtext", null), e([g({
  type: String
})], M.prototype, "brandtexttop", null), e([g({
  type: String
})], M.prototype, "brandtextbottom", null), e([g({
  type: String
})], M.prototype, "pickregiontext", null), e([g({
  type: Boolean
})], M.prototype, "hidebrand", null), e([g({
  type: Boolean,
  reflect: !0
})], M.prototype, "fluid", null), e([g({
  type: Boolean
})], M.prototype, "hideregionpicker", null), e([g({
  type: String
})], M.prototype, "srlogolabel", null), e([g({
  type: Boolean,
  reflect: !0
})], M.prototype, "unresponsive", null), e([g({
  type: String
})], M.prototype, "logohref", null), e([u()], M.prototype, "isRegionExpanded", null), e([u()], M.prototype, "regionIcon", null);
export { M as IDSHeader };